import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// ✅ NEW: Error Boundary
import ErrorBoundary from './components/ErrorBoundary'

// Performance monitoring
import { reportWebVitals } from './lib/performance'

// Error tracking - async init
import { initErrorTracking } from './lib/error-tracking'

// Analytics
import { trackPageView } from './lib/analytics'

// Accessibility
import { showKeyboardFocus } from './utils/accessibility'

// Initialize error tracking (async - won't block rendering)
initErrorTracking().catch(() => {})

// Enable keyboard focus indicators
showKeyboardFocus()

// Track page views
const originalPushState = window.history.pushState
window.history.pushState = function(...args) {
  originalPushState.apply(this, args)
  trackPageView(window.location.pathname, document.title)
}

// Track initial page view
trackPageView(window.location.pathname, document.title)

// Performance monitoring
if (import.meta.env.PROD) {
  reportWebVitals(console.log)
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)